import script from "./BrainIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./BrainIndex.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/BrainIndex.css?vue&type=style&index=0&id=51728ec8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51728ec8"]])

export default __exports__